import { makeStyles } from '@material-ui/core';

export const AppContainerStyle = makeStyles(({ breakpoints }) => ({
    maintenanceBanner: {
        width: '100%',
        backgroundColor: '#000000',
        color: '#ffffff',
        padding: '12px 16px',
        textAlign: 'center',
        '& p': {
            margin: 0,
        },
        '& a': {
            color: 'inherit',
            textDecoration: 'underline',
        },
    },
    root: {
        padding: '24px 65px',
        minHeight: 'calc(100vh - 146px)',
        [breakpoints.down('xs')]: {
            minHeight: 'calc(100vh - 228px)',
            padding: '12px 24px',
        },
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-start',
    },
}));
